import { TEST_STATUS_TYPES, FLAGS_CONFIG } from "./constants";
import { appsyncConfig } from "./config";

export const createTestSuiteResponseObject = (
  testSuiteType,
  unitTestName,
  testSuiteIsPassed
) => {
  const testSuiteStatusName = testSuiteIsPassed
    ? TEST_STATUS_TYPES.succeeded
    : TEST_STATUS_TYPES.failed;

  const TestSuiteResponseObject = {
    testSuiteType: testSuiteType,
    unitTestName: testSuiteIsPassed ? "All in suite" : unitTestName,
    testSuiteIsPassed: testSuiteIsPassed,
    testSuiteStatusName: testSuiteStatusName,
  };
  TestSuiteResponseObject.message =
    `The ${testSuiteType} Test suite ${testSuiteStatusName}` +
    (testSuiteIsPassed
      ? ""
      : `because of a failure in the ${unitTestName} check`);

  return TestSuiteResponseObject;
};

export const createUnitTestResponseObject = (
  passed,
  errorDetails,
  property,
  test_performed
) => {
  return {
    passed: passed,
    errorDetails: errorDetails,
    property: property,
    test_performed: test_performed,
  };
};

export const createErrorDetails = (value, index, property, message) => {
  return { Value: value, Index: index, Property: property, Message: message };
};

export const createCheckDuplicatesErrorMessage = (property, value) => {
  return `The ${property} "${value}" is duplicated.`;
};

export const createCheckExistsInErrorMessage = (
  property,
  value,
  indexBool = false
) => {
  return `The value cannot be ${value} for property "${property}"${
    indexBool ? " at this index" : ""
  }.`;
};

export const buildEnvironmentSelectionConfig = () => {
  const selectionConfig = [];

  Object.keys(appsyncConfig).forEach((key) => {
    if (FLAGS_CONFIG[key]) {
      selectionConfig.push({
        key: key,
        name: FLAGS_CONFIG[key].name,
        flag: FLAGS_CONFIG[key].flag,
        value: appsyncConfig[key],
      });
    }
  });

  return selectionConfig;
};
